export const IMAGE_FILE_SIZE_MAX = 5242880; // 5*1024*1024,
